import { orderStatus, mapControl, attendCode, } from '@/constants';
import { i18n } from '@/locales';
import FulfillmentUser from './FulfillmentUser';
import FulfillmentGroup from './FulfillmentGroup';
import FulfillmentOrderInfo from './FulfillmentOrderInfo';
import FulfillmentLocation from './FulfillmentLocation';
const { orderStatusGroup, } = mapControl;
export default class Fulfillment {
    /** 퇴근 여부 (다양한 이유로 현재 운행중이 아닐 수 있음) */
    isOff = false;
    /** 공유워커 여부 */
    isShareWorker = false;
    /** 유저 */
    user = new FulfillmentUser();
    /** 워커 소속 (허브) */
    group = new FulfillmentGroup();
    /** 위치 */
    location = new FulfillmentLocation();
    /** 주문 정보 */
    orderInfo = [];
    /** 가중치 */
    relatedWeight = 0;
    /** 배차 수량 */
    allocatedCount = 0;
    /** 픽업 수량 */
    pickupCount = 0;
    /** 임시 퇴근 여부 */
    isTemporallyOff;
    /** 배차 취소 아이디 */
    allocateCancelIds = [];
    constructor(fulfillmentData) {
        try {
            if (!fulfillmentData) {
                this.isOff = true;
                return;
            }
            // 리스트 가중치. 워커의 경우 마커가 아닌 리스트에서 가중치를 가지고 있어야 함. 1:n이 가능함.
            this.relatedWeight = 0;
            this.allocatedCount = 0;
            this.pickupCount = 0;
            this.isShareWorker = false;
            // 임시 퇴근 여부. 배차건이 있으나 퇴근 상태 === 임시 퇴근
            this.isTemporallyOff = false;
            // 제거가 필요한 주문들
            this.allocateCancelIds = [];
            Object.assign(this, fulfillmentData);
            this.user = new FulfillmentUser(fulfillmentData?.user);
            this.group = new FulfillmentGroup(fulfillmentData?.group);
            this.orderInfo = fulfillmentData.orderInfo.map((item) => new FulfillmentOrderInfo(item));
            // TODO 명확해지기 전까지 ON을 WAITING으로 에러만 방지
            this.user.attendCode = this.user.attendCode === attendCode.ON.code
                ? attendCode.WAITING.code
                : this.user.attendCode;
            this.updateOrderCount();
        }
        catch (error) {
            console.log(error);
        }
    }
    /** 워커 허브명 */
    get workerHubName() {
        return this.group.hubId;
    }
    /** 워커 코드 */
    get code() {
        return this.user.code;
    }
    /** 워커 사번 */
    // eslint-disable-next-line class-methods-use-this
    get workerHubNumber() {
        return '-';
    }
    /** 워커 이름 */
    get workerName() {
        return this.user.name;
    }
    /** 워커 상태 */
    get workerAttendCode() {
        return i18n.t(attendCode[this.user.attendCode].text);
    }
    /** 워커 전화 번호 */
    get workerPhoneNumber() {
        return this.user.phoneNumber;
    }
    /** 거리 (무슨 거리지..?) */
    get geoWorkerDistance() {
        return this.user.geoWorkerDistance;
    }
    /**
     * 워커의 특정 주문 제거
     * @param _orderId 주문 번호
     */
    deleteOrder(_orderId) {
        this.orderInfo = this.orderInfo
            .filter((value) => value.orderId.toString() !== _orderId.toString());
    }
    /**
     * 배차취소건 리스트 초기화
     */
    truncateAllocateCancelIds() {
        this.allocateCancelIds = [];
    }
    /**
     * 운행건이 없는 공유 라이더
     */
    get isWaitingShareWorker() {
        return this.isShareWorker && this.isEmptyOrder();
    }
    /**
     * 퇴근 라이더
     */
    get isOffWorker() {
        return this.user.attendCode === attendCode.OFF.code;
    }
    /**
     * @param newAttendCode 상태값 업데이트
     */
    set updateAttendCode(newAttendCode) {
        this.user.attendCode = newAttendCode;
    }
    /**
     * 임시퇴근라이더 여부 셋팅
     */
    updateTemporallyOffState() {
        const { orderInfo } = this;
        if (this.isOffWorker && orderInfo.length > 0) {
            this.updateAttendCode = attendCode.DRIVING.code;
            this.isTemporallyOff = true;
        }
    }
    /**
     * @param _relatedWeight 가중치
     */
    setRelatedWeight(_relatedWeight) {
        this.relatedWeight = _relatedWeight;
    }
    /**
     * 현재 들고 있는 주문 없는지 유무
     * @returns
     */
    isEmptyOrder() {
        return !this.allocatedCount && !this.pickupCount;
    }
    /**
     * 공유 워커 여부
     * @param targetId 총판 혹은 허브 아이디 (Hxxxx, Bxxxx)
     * @returns
     */
    setShareWorker(targetId) {
        if (!targetId) {
            console.log('[setShareWorker] invalid parameter');
            return;
        }
        const { group } = this;
        // 총판은 H, 허브는 B로 시작함
        const keyName = targetId.indexOf('H') === 0 ? 'distributorId' : 'hubId';
        if (targetId !== group[keyName]) {
            this.isShareWorker = true;
            return;
        }
        this.isShareWorker = false;
    }
    /**
     * 현재 주문 기준으로 라이더의 주문 수량을 업데이트 한다.
     */
    updateOrderCount() {
        let allocatedCount = 0;
        let pickupCount = 0;
        this.orderInfo = this.orderInfo.filter((order) => {
            const { statusCode, orderId, } = order;
            const type = orderStatusGroup[statusCode];
            switch (type) {
                case orderStatus.ALLOCATED.code:
                    allocatedCount += 1;
                    break;
                case orderStatus.PICKUP.code:
                    pickupCount += 1;
                    break;
                default: break;
            }
            // 주문 취소건 트랙킹 필요 없음
            if (statusCode === orderStatus.ALLOCATE_CANCEL.code) {
                this.allocateCancelIds.push(orderId);
                return false;
            }
            return true;
        });
        this.allocatedCount = allocatedCount;
        this.pickupCount = pickupCount;
    }
}
